import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import {PtrnAccionPametroAuxiliar, PtrnCampoEditableArray} from '../../../patronTypes';
import {EditableProps} from '../campoEditableTypes';
import {useInputStyles} from '../campoEditableUtils';
import {PtrnPropsUtil} from '../../../patronUtils';

function CampoEditableRadio(
   props: {campoConfig: PtrnCampoEditableArray} & EditableProps & {
         ErrorComponent?: React.ReactNode;
      }
) {
   const {campoConfig, ...editableProps} = props;
   const classes = useInputStyles();

   const auxParam = {
      camposData: editableProps.camposData,
      campoConfig: campoConfig,
      ptrnRef: editableProps.ptrnRef,
      ruta: editableProps.ruta,
      index: editableProps.index
   };

   const labelItem = (campoValor: any, auxParam?: PtrnAccionPametroAuxiliar): string => {
      if (campoConfig.generarDenominacionMostrar) {
         return campoConfig.generarDenominacionMostrar(campoValor, auxParam);
      }

      // Asegurarte de que sea un string o renderizable
      if (typeof campoValor === 'object') {
         return JSON.stringify(campoValor); // Convierte el objeto a string
      }
      return campoValor.toString(); // Convierte otros valores a string
   };

   const labelItemSelected = (campoValor: any, auxParam?: PtrnAccionPametroAuxiliar): string => {
      if (campoConfig.generarValorMostrar) {
         return campoConfig.generarValorMostrar(campoValor, auxParam);
      }

      // Asegurarte de que sea un string o renderizable
      if (typeof campoValor === 'object') {
         return JSON.stringify(campoValor); // Convierte el objeto a string
      }
      return campoValor.toString(); // Convierte otros valores a string
   };

   const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      const name = e.target.name;
      let newValue = JSON.parse(e.target.value);
      editableProps.onChange(name, newValue, auxParam);
   };

   //#region GEN PROPS
   const id = PtrnPropsUtil.genIdCampoEditable(campoConfig);
   const endAdornments = props.ErrorComponent ? (
      <InputAdornment position="end">{props.ErrorComponent}</InputAdornment>
   ) : undefined;
   //#endregion

   //#region RETORNOS

   return (
      <FormControl fullWidth error={Boolean(props.ErrorComponent)} component="fieldset">
         <FormLabel component="legend">{campoConfig.label}</FormLabel>
         <RadioGroup
            value={JSON.stringify(editableProps.value)}
            onChange={handleOnChange}
            id={id}
            name={campoConfig.name}
            row={campoConfig.row}
         >
            {campoConfig.array && campoConfig.array.length > 0 ? (
               campoConfig.array.map((item, index) => {
                  const itemValue = JSON.stringify(item);
                  const isSelected = JSON.stringify(editableProps.value) === itemValue;
                  const auxParam: PtrnAccionPametroAuxiliar = {
                     campoConfig: campoConfig,
                     camposData: editableProps.camposData,
                     ptrnRef: editableProps.ptrnRef,
                     index: index
                  };
                  return (
                     <FormControlLabel
                        key={`${id}-item-${index}`}
                        value={itemValue}
                        control={<Radio />}
                        label={
                           isSelected
                              ? labelItemSelected(item, auxParam)
                              : labelItem(item, auxParam)
                        }
                     />
                  );
               })
            ) : (
               <Typography padding={'10px'} color="error">
                  {campoConfig.emptyMessage || 'No hay opciones disponibles.'}
               </Typography>
            )}
         </RadioGroup>
      </FormControl>
   );
   //#endregion
}

export default CampoEditableRadio;
